/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personalitybigfiveextraversionleft4Inputs */



/**
* | output |
* | --- |
* | "Introvert" |
*
* @param {Personalitybigfiveextraversionleft4Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const personalitybigfiveextraversionleft4 = /** @type {((inputs?: Personalitybigfiveextraversionleft4Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personalitybigfiveextraversionleft4Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Introvert")
	if (locale === "es") return /** @type {LocalizedString} */ ("Introvertido")
	return /** @type {LocalizedString} */ ("Интроверт")
});
export { personalitybigfiveextraversionleft4 as "personalityBigFiveExtraversionLeft" }